import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { List, Datagrid, TextField, ImageField, TextInput, FunctionField, Filter} from "react-admin";
import CustomActions from "../../../components/CustomActions";
import { ListPagination, downloadCsv } from "../../../utils";
import TYPE_CONTENT_ENUM from "../enums/type-content-enum";

const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    Título: item.title,
    Descrição: item.description,
    "Botão Personalizado": item.label,
    Ciclo: item?.cycle[0]?.id,
    "Tipo de Conteúdo": (() => {
      const TYPE_CONTENT_LABEL = {
        [TYPE_CONTENT_ENUM.URL]: "URL",
        [TYPE_CONTENT_ENUM.FILE]: "Arquivo",
      };
      return TYPE_CONTENT_LABEL[item.typeContent?.id] || "";
    })(),
    URL: item.url,
    Imagem: item.icon,
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Título", "Descrição", "Botão Personalizado", "Ciclo", "Tipo de Conteúdo","URL", "Imagem"],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "ads"); // download as 'posts.csv` file
};

const AdFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Título" source="title" alwaysOn />
    <TextInput label="Descrição" source="description" />
    <TextInput label="Ciclo" source="cycle.id" />
    <TextInput label="URL" source="url" />
  </Filter>
);

const AdList = (props) => (
  <List
    perPage={25}
    bulkActionButtons={<div />}
    title="Lista de Anúncios"
    actions={<CustomActions />}
    exporter={exporter}
    hasCreate={true}
    filters={<AdFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Título" source="title" />
      <TextField label="Descrição" source="description" />
      <TextField sortable={false} label="Ciclo" source="cycle[0].id" />
      <TextField label="Botão Personalizado" source="label" />
      <FunctionField
        label="Tipo de Conteúdo"
        render={(record = {}) => {
          const id = record?.typeContent?.id;
          if (id === TYPE_CONTENT_ENUM.FILE) return "Arquivo";
          if (id === TYPE_CONTENT_ENUM.URL) return "URL";
          return "";
        }}
      />
      <FunctionField
        label="URL"
        render={(record = {}) =>
          record?.url ? (
            <a href={record.url} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'underline' }}>
              {record.urlName ? record.urlName : record.url}
            </a>
          ) : null
        }
      />
      <ImageField label="Imagem" source="icon" />
    </Datagrid>
  </List>
);

export default AdList;
